/* Polyfill for promise allsettled */
if (!('allSettled' in Promise))
  // eslint-disable-next-line func-names
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map(p =>
        p
          .then(value => ({
            status: 'fulfilled',
            value
          }))
          .catch(reason => ({
            status: 'rejected',
            reason
          }))
      )
    );
  };
